import { html, LitElement } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import { InputWidthValues } from '../../gzInput';
import { GzCarouselInfoOverlay } from '../component/GzCarouselInfoOverlay';
import { carouselMockData } from './mockData';

@customElement('carousel-info-overlay-story')
export class CarouselInfoOverlayStory extends LitElement {
  @query('#element1')
  element1: HTMLElement;

  @query('#element2')
  element2: HTMLElement;

  @query('#element3')
  element3: HTMLElement;

  @query('#element4')
  element4: HTMLElement;

  firstUpdated() {
    GzCarouselInfoOverlay.show(
      'blabla',
      carouselMockData,
      [this.element1, this.element2, this.element3, this.element4],
      'Close'
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.getElementsByTagName('gz-carousel-info-card')?.[0]?.remove();
  }

  render() {
    return html`
      <div style="width: 100%; height: 80vh; display: flex; flex-direction: column; justify-content: space-between;">
        <div style="display: flex; justify-content: space-between;">
          <gz-input id="element1" placeholder="Some input" inputWidth="${InputWidthValues.LARGE}"></gz-input>
          <gz-button id="element2"> Some button </gz-button>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <gz-icon id="element4" name="ds-icon-add" size="20"></gz-icon>
          <gz-textarea id="element3" placeholder="Some textarea" style="width: 300px"></gz-textarea>
        </div>
      </div>
    `;
  }
}
